module.exports = __webpack_public_path__ + "img/订金缴费.626a363c.png";